import React from "react";
import "./SharedStyles.scss";
import { IoMdAlert, IoMdCheckmarkCircle, IoMdWarning } from "react-icons/io";

interface IProps {
  message: string;
  type: "error" | "warning" | "success" | "gray";
  showOnlyIcon?: boolean;
  compact?: boolean;
  variant?: "default" | "chip";
  dangerouslySetInnerHTML?: boolean;
  buttonText?: string;
  onButtonClick?: () => void;
}

const EAAlert: React.FC<IProps> = ({
  message,
  type,
  showOnlyIcon = false,
  compact = false,
  variant = "default",
  dangerouslySetInnerHTML = false,
  buttonText,
  onButtonClick,
}) => {
  const getIcon = (type: "success" | "error" | "warning" | "gray") => {
    switch (type) {
      case "success":
        return <IoMdCheckmarkCircle />;
      case "error":
        return <IoMdAlert />;
      case "warning":
        return <IoMdWarning />;
      case "gray":
        return <IoMdCheckmarkCircle />;
      default:
        return null;
    }
  };

  const icon = getIcon(type);

  const alertClasses = `ea-alert ea-alert--${type} ${showOnlyIcon ? "ea-alert__only-icon" : ""} ${
    compact ? "ea-alert--compact" : ""
  } ${variant === "chip" ? "ea-alert--chip" : ""}`.trim();

  if (showOnlyIcon || message === "") {
    return (
      <div className={alertClasses}>
        <span className="ea-alert__icon">{icon}</span>
      </div>
    );
  }

  return (
    <div className={alertClasses}>
      <span className="ea-alert__icon">{icon}</span>
      {dangerouslySetInnerHTML ? (
        <span className="ea-alert__message" dangerouslySetInnerHTML={{ __html: message }} />
      ) : (
        <span className="ea-alert__message">
          {message}
          {buttonText && onButtonClick && (
            <span onClick={onButtonClick} className={"ea-alert__button"}>
              {buttonText}
            </span>
          )}
        </span>
      )}
    </div>
  );
};

export default EAAlert;
